import {
    type FC,
    type ReactNode,
    createContext,
    useState,
    useCallback,
    type RefObject,
} from 'react';
import { useDebouncedCallback } from 'dibs-react-hooks/exports/useDebouncedCallback.js';
import { useResizeObserver } from 'dibs-react-hooks/exports/useResizeObserver.ts';

export type QuickView = {
    openQuickView?: (index: number) => void;
    closeQuickView?: () => void;
    activeQuickView?: number | null;
};

export const QuickViewContext = createContext<QuickView>({});

type Props = {
    elementRef: RefObject<HTMLElement | null>;
    children: ReactNode;
};

export const QuickViewProvider: FC<Props> = ({ children, elementRef }) => {
    const [activeQuickView, setActiveQuickView] = useState<number | null>(null);

    const openQuickView = useCallback((index: number): void => setActiveQuickView(index), []);
    const closeQuickView = useCallback(() => setActiveQuickView(null), []);
    const [onResize] = useDebouncedCallback(closeQuickView);

    useResizeObserver(elementRef, onResize);

    return (
        <QuickViewContext value={{ openQuickView, closeQuickView, activeQuickView }}>
            {children}
        </QuickViewContext>
    );
};
